import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ApplyForAccreditation from './ApplyForAccreditation';

const Unauthorized = ({ hasInProgressForm = false }) => {
  return (
    <>
      <h1 className="dashboard__header">Dashboard</h1>
      <div className="dashboard__content">
        <div className="dashboard__banner">
          <va-alert status="warning" visible>
            <h2 slot="headline">We can’t verify your accreditation</h2>
            <p>
              If you’re accredited and want full access to the portal, your
              account needs to be associated with the email you have on file
              with Office of General Counsel (OGC). Check to make sure you
              created your account correctly.
            </p>
            <Link to="/help#creating-your-account">
              Learn about creating your account
            </Link>
          </va-alert>
        </div>
        <ApplyForAccreditation hasInProgressForm={hasInProgressForm} />
      </div>
    </>
  );
};

Unauthorized.propTypes = {
  hasInProgressForm: PropTypes.bool,
};

export default Unauthorized;
